"use client";

import React from "react";
import { useApp } from "@/forApp/states/appState/appState";
import type { BaseEntityT } from "@/forApp/types/Entity";
import fetcher from "@/forApp/utils/fetcher/fetcher";
import Button from "@/shared/Buttons/Button";
import Modal from "@/shared/Modal/Modal";
import styles from "./styles.module.css";

interface ArchiveObjectModalProps {
	object: BaseEntityT;
	mutate: () => void;
}

const ArchiveObjectModal: React.FC<ArchiveObjectModalProps> = ({
	object,
	mutate,
}) => {
	const { delModal, addNotification } = useApp();
	const [isLoading, setIsLoading] = React.useState(false);

	const archivePromo = async () => {
		setIsLoading(true);
		try {
			await fetcher("DELETE", `/personal/entities/${object.slug}`);
			addNotification({
				text: "Объявление перемещено в архив",
				type: "success",
			});
			mutate();
			delModal();
		} catch (error) {
			console.error("Error archiving object:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleCancel = () => {
		delModal();
	};

	return (
		<Modal title="Архивация объекта">
			<div className={styles.modalContent}>
				<p className={styles.message}>
					Вы уверены что хотите добавить объект{" "}
					<span className={styles.objectName}>{object.full_address}</span> в
					архив?
				</p>

				<div className={styles.buttonsContainer}>
					<Button
						text={isLoading ? "Архивация..." : "Да"}
						color="red"
						onClick={archivePromo}
						isLoading={isLoading}
					/>
					<Button
						text="Нет"
						color="gray"
						onClick={handleCancel}
						disabled={isLoading}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default ArchiveObjectModal;
